import { Builder_, CardsSixty, Checkbox_, Dropdown_, Input_, Section_Title, Slider_ } from 'monica-alexandria';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const CheckboxWrapper = styled.div``;

export default function Edit_Row(props) {
    const { t } = useTranslation();
  
    const blockSections = ['overview'];
    const blockRows = ['demographics', 'graphical'];

    return (
        <Slider_ onClick={props.onClick} text={t('Done')} title={t('Edit row')}>
            <Builder_ title={t('Edit the title of the row')}>
                <Input_ placeholder={""} defaultValue={props.row?.rowTitle} onChange={(e) => props.onEditName(e.target.value)} />
            </Builder_>
            {props.rowType !== 'demographics' ?
                <Builder_ title={t('Edit the style of the indicator')}>
                    <Dropdown_>
                        <select onChange={(e) => props.onUpdateColor(e.target.value)}>
                            {props.sectionType !== 'paid' ? 
                            <>
                                <option value="main">{t('Primary')}</option>
                                <option value="focus">{t('Secondary')}</option>
                            </>
                            : 
                            <>
                                <option value="focus">{t('Primary')}</option>
                                <option value="main">{t('Secondary')}</option>
                            </>
                            }
                            <option value="mainInverted">{t('Primary inverted')}</option>
                            <option value="focusInverted">{t('Secondary inverted')}</option>
                            <option value="simple">{t('Simple')}</option>
                        </select>
                    </Dropdown_>
                </Builder_>
                :
                null}
            {!blockRows.includes(props.rowType) && !blockSections.includes(props.sectionType) ? (
                <CheckboxWrapper>
                    <Section_Title text={t('Options')} />
                    <CardsSixty>
                        <Checkbox_ text="Display compared values" 
                            checked={props?.row?.isCompared} 
                            onChange={() => props.toggleCompareOption(props?.row?.isCompared ? 'hide' : 'show')} 
                        />
                    </CardsSixty>
                </CheckboxWrapper>
            ) : null}
        </Slider_>
    );
}
